import styled from 'styled-components'

const Styled = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid #d9d9d9;
  border-radius: 10px;
  padding: 15px;
  cursor: pointer;

  .role-name {
  }

  .role-check {
    margin-left: 20px;
  }

  &.active {
  }
`

export default Styled
